import { Navigate, Outlet, RouteObject } from "react-router-dom";

import { FeatureFlagToggle } from "@/domain/_shared/feature-flag/components/feature-flag-toggle";
import { TrashPage } from "@/domain/trash/components/trash-page";
import { TrashScope } from "@/domain/trash/hooks/api/trash.gql";
import { MUNICIPAL_PROPERTY_CONSUMPTION_FEATURE_FLAG_ID, MUNICIPAL_PROPERTY_FEATURE_FLAG_ID } from "@ark/shared";

import { MunicipalPropertyLayout } from "./municipal-property.layout";
import { MUNICIPAL_PROPERTY_SEGMENT } from "./municipal-property-base-path";
import { MunicipalPropertyCatalogPage } from "./municipal-property-catalog.page";
import { MUNICIPAL_PROPERTY_CATALOG_PATH } from "./municipal-property-catalog-path";
import { MunicipalPropertyIndexPage, MunicipalPropertyWorkspaceRedirect } from "./municipal-property-index.page";
import { MunicipalPropertyRegisterDetailPage } from "./municipal-property-register-detail.page";
import { MunicipalPropertyRegisterListPage } from "./municipal-property-register-list.page";
import { MUNICIPAL_PROPERTY_REGISTER_LIST_PATH } from "./municipal-property-register-list-path";
import { MunicipalPropertyYearPage } from "./municipal-property-year.page";
import { MunicipalPropertyYearDataPage } from "./municipal-property-year-data.page";

export const municipalPropertyRouteList: RouteObject[] = [
  {
    path: `workspace/${MUNICIPAL_PROPERTY_SEGMENT}`,
    element: <Outlet />,
    children: [
      { index: true, element: <MunicipalPropertyIndexPage /> },
      {
        element: (
          <FeatureFlagToggle
            flag={MUNICIPAL_PROPERTY_FEATURE_FLAG_ID}
            isDevelopmentBypassAllowed={false}
            fallback={<MunicipalPropertyWorkspaceRedirect />}
          >
            <MunicipalPropertyLayout section="catalog" />
          </FeatureFlagToggle>
        ),
        children: [
          { path: MUNICIPAL_PROPERTY_CATALOG_PATH, element: <MunicipalPropertyCatalogPage /> },
          {
            path: "trash",
            element: (
              <FeatureFlagToggle
                flag="enable-trash"
                fallback={<Navigate to={`../${MUNICIPAL_PROPERTY_CATALOG_PATH}`} replace />}
              >
                <TrashPage scope={TrashScope.WORKSPACE} entityType="municipalProperty" />
              </FeatureFlagToggle>
            ),
          },
        ],
      },
      {
        element: (
          <FeatureFlagToggle
            flag={MUNICIPAL_PROPERTY_CONSUMPTION_FEATURE_FLAG_ID}
            isDevelopmentBypassAllowed={false}
            fallback={<MunicipalPropertyWorkspaceRedirect />}
          >
            <MunicipalPropertyLayout section="register" />
          </FeatureFlagToggle>
        ),
        children: [
          { path: MUNICIPAL_PROPERTY_REGISTER_LIST_PATH, element: <MunicipalPropertyRegisterListPage /> },
          {
            path: `${MUNICIPAL_PROPERTY_REGISTER_LIST_PATH}/trash`,
            element: (
              <FeatureFlagToggle
                flag="enable-trash"
                fallback={<Navigate to={`../${MUNICIPAL_PROPERTY_REGISTER_LIST_PATH}`} replace />}
              >
                <TrashPage scope={TrashScope.WORKSPACE} entityType="municipalPropertyRegister" />
              </FeatureFlagToggle>
            ),
          },
          {
            path: `${MUNICIPAL_PROPERTY_REGISTER_LIST_PATH}/years/trash`,
            element: (
              <FeatureFlagToggle
                flag="enable-trash"
                fallback={<Navigate to={`../${MUNICIPAL_PROPERTY_REGISTER_LIST_PATH}`} replace />}
              >
                <TrashPage scope={TrashScope.WORKSPACE} entityType="municipalPropertyYear" />
              </FeatureFlagToggle>
            ),
          },
          {
            path: `${MUNICIPAL_PROPERTY_REGISTER_LIST_PATH}/:registerId`,
            element: <MunicipalPropertyRegisterDetailPage />,
            children: [
              {
                path: ":propertyYearId",
                element: <MunicipalPropertyYearPage />,
                children: [
                  { index: true, element: <Navigate to="data" replace /> },
                  { path: "details", element: <Navigate to="../data" replace /> },
                  { path: "data", element: <MunicipalPropertyYearDataPage /> },
                ],
              },
            ],
          },
        ],
      },
    ],
  },
];
